const StripeLogo = ({ height = 18 }) => (
    <svg
        height={height}
        viewBox="0 0 60 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        style={{ display: 'inline-block', verticalAlign: 'middle' }}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M59.64 14.28h-8.06c.19 1.93 1.6 2.55 3.2 2.55 1.64 0 2.96-.37 4.05-.95v3.32a8.33 8.33 0 0 1-4.56 1.1c-4.01 0-6.83-2.5-6.83-7.48 0-4.19 2.39-7.52 6.3-7.52 3.92 0 5.96 3.28 5.96 7.5 0 .4-.04 1.26-.06 1.48zm-5.92-5.62c-1.03 0-2.17.73-2.17 2.58h4.25c0-1.85-1.07-2.58-2.08-2.58zM40.95 20.3c-1.44 0-2.32-.6-2.89-1.03l-.02 4.63-4.12.87V5.57h3.76l.08 1.02a4.7 4.7 0 0 1 3.23-1.29c2.9 0 5.62 2.6 5.62 7.4 0 5.23-2.7 7.6-5.66 7.6zM40 8.95c-.95 0-1.54.34-1.97.81l.02 6.12c.4.44.98.78 1.95.78 1.52 0 2.54-1.65 2.54-3.87 0-2.15-1.04-3.84-2.54-3.84zM28.24 5.57h4.13v14.44h-4.13V5.57zm0-4.7L32.37 0v3.36l-4.13.88V.87zm-4.32 9.35v9.79H19.8V5.57h3.7l.12 1.22c1-1.77 3.07-1.41 3.62-1.22v3.79c-.52-.17-2.29-.43-3.32.86zm-8.55 4.72c0 2.43 2.6 1.68 3.12 1.48v3.28c-.55.3-1.54.5-2.71.5-2.97 0-4.49-2.01-4.49-4.98V8.57H9.31V5.5h1.98V2.7l4.08-.86v3.73h3.12v3.07h-3.12v4.37zM5.52 9.28c0-.62.52-.87 1.35-.87 1.2 0 2.72.36 3.92 1v-3.7A10.46 10.46 0 0 0 6.8 5.3C3.01 5.3.7 7.22.7 9.71c0 3.81 5.24 3.2 5.24 4.84 0 .73-.63 1-1.51 1-1.3 0-2.97-.54-4.28-1.26v3.74c1.46.62 2.93.88 4.28.88 3.88 0 6.54-1.92 6.54-4.44 0-4.1-5.45-3.39-5.45-5.19z"
            fill="currentColor"
        />
    </svg>
)

const ITEMS = [
    {
        label: 'Escrow-protected campaigns',
        stripe: false,
    },
    {
        label: 'GDPR-compliant',
        stripe: false,
    },
    {
        label: 'Pays out in EUR & USD',
        stripe: false,
    },
]

function TrustStrip() {
    return (
        <div className="trust-strip">
            <ul className="trust-strip__list">
                <li className="trust-strip__item trust-strip__item--stripe">
                    <span className="trust-strip__powered-by">Payments powered by</span>
                    <StripeLogo height={16} />
                </li>
                {ITEMS.map((item, i) => (
                    <li key={i} className="trust-strip__item">
                        {item.label}
                    </li>
                ))}
            </ul>
        </div>
    )
}

export default TrustStrip
